import React from 'react'
import to from 'await-catch'
import styled from 'styled-components'
import { cancelCheckInAppointment } from '../../api'
import theme from '../../styles/theme'
import { getCurrentTimeRangeStatus, TIME_RANGE_STATUS } from '../../utils/isCurrentTimeInRange'
import { Success } from '../../assets/icons'

const SuccesfulTurn = ({ data, clear }) => {
  const clinic = data && data.clinic ? data.clinic : {}
  const timeRangeStatus = getCurrentTimeRangeStatus(
    clinic.horaInicio,
    clinic.horaFin
  )
  const isNearClose = timeRangeStatus === TIME_RANGE_STATUS.NEAR_END

  const exit = async () => {
    const params = {
      clinica: data.clinic.id,
      turno: data.turno
    }
    await to(cancelCheckInAppointment(params))

    clear();
  }

  const getTimeWithWait = (minutes) => {
    const now = new Date();
    now.setMinutes(now.getMinutes() + minutes);

    return now.toLocaleTimeString('es-AR', {
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    });
  };

  return (
    <PageWrapper>
      <ProcessingPaymentContainer>
        <Content>
          <IconWrapper>
            <Success size={72} alt="Éxito" />
          </IconWrapper>

          <ProcessingPaymentTitle>
            Estás en la fila de la {data.speciality.name.toLowerCase()} de {data.clinic.name}
          </ProcessingPaymentTitle>

          <ProcessingPaymentSubtitle>
            Te esperamos a las {getTimeWithWait(data.clinic.waitTime)}
          </ProcessingPaymentSubtitle>

          <ProcessingPaymentText>
            Anunciate sin hacer la fila mostrando esta pantalla en la admisión de la guardia
          </ProcessingPaymentText>

          <ProcessingPaymentText>
            Recordá que la prioridad en la atención médica está dada por el problema de salud identificado,
            no por el lugar de la fila asignado.
          </ProcessingPaymentText>

          {isNearClose && (
            <MessageContainer>
              <Text2 fontWeight="600">Estás cerca del cierre de la guardia</Text2>
              <Text2>
                Después de las 20:00 no habrá médicos disponibles ni se recibirán nuevos pacientes.{' '}
              </Text2>
            </MessageContainer>
          )}

          <LinkWrapper>
            <ExitLink onClick={() => exit()}>Salir de la fila</ExitLink>
          </LinkWrapper>

        </Content>
      </ProcessingPaymentContainer>
    </PageWrapper>
  )
}


const PageWrapper = styled.div`
	min-height: 100vh;
	display: flex;
	flex-direction: column;
`

const ProcessingPaymentContainer = styled.main`
	flex: 1;
	display: flex;
	justify-content: center;
	padding: 40px 16px;
`

const Content = styled.div`
	max-width: 532px;
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	text-align: center;
`

const IconWrapper = styled.div`
	margin-bottom: 24px;

	svg {
		width: 56px;
		height: 56px;
	}
`

const ProcessingPaymentTitle = styled.h1`
	font-size: 24px;
	font-weight: 600;
	margin: 0;
	margin-bottom: 12px;
`

const ProcessingPaymentSubtitle = styled.h2`
	font-size: 18px;
	font-weight: 600;
	margin: 0;
	margin-bottom: 8px;
	color: #525252;
`

const NearCloseMessage = styled(ProcessingPaymentSubtitle)`
  color: ${theme.colors.brand.blueOmint};
`

const ProcessingPaymentText = styled.p`
	font-size: 16px;
	margin-bottom: 8px;
	margin-top: 0;
	color: #555;
	font-weight: 400;
`

const ExitLink = styled.button`
	background: none;
	border: none;
	color: ${theme.colors.brand.blueOmint};
	font-size: 16px;
	cursor: pointer;
	padding: 0;
	margin-top: 32px;
	text-decoration: underline;
	font-weight: 600;
`

const MessageContainer = styled.div`
	padding: 16px;
	width: 100%;
	gap: 16px;
	display: flex;
	flex-direction: column;
	background: ${theme.colors.brand.backgroundBlue};
`
const LinkWrapper = styled.div`
	@media (max-width: ${props => props.theme.sizes.breakPoints.small}) {
		display: flex;
		flex-direction: column;
		position: fixed;
		bottom: 0;
		left: 0;
		width: 100%;
		height: 10vh;
		background: white;
		padding: 1rem;
		z-index: 10;
		border-bottom: 0.5rem solid ${theme.colors.brand.green};
	}
`

const Text2 = styled.p`
    font-size: ${props => props.size || '16px'};
    line-height: ${props => props.lineHeight || '16px'};
    color: ${props => props.color || props.theme.colors.brand.blueOmint};
    font-weight: ${props => props.fontWeight || 400};
    margin: 0;
`

export default SuccesfulTurn
